var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _c('el-form', {
    attrs: {
      "label-position": "left",
      "size": "small",
      "inline": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User's email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: _vm.email,
      callback: function ($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.admin,
      expression: "loading.admin"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.newAdmin
    }
  }, [_vm._v("Make user admin")])], 1)], 1), _c('Table', {
    attrs: {
      "items": _vm.admins,
      "columns": _vm.columns,
      "actions": _vm.actions,
      "filterProp": "email",
      "loading": _vm.loading.admins
    }
  }), _c('Dialog', {
    attrs: {
      "title": "Edit Admin",
      "show": _vm.showEditDialog,
      "onClose": function () {
        return _vm.showEditDialog = false;
      }
    }
  }, [_c('AccountForm', {
    attrs: {
      "account": _vm.account,
      "afterSave": function () {
        return _vm.showEditDialog = false;
      }
    }
  })], 1)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header"
  }, [_c('h4', [_vm._v("Admins")])]);

}]

export { render, staticRenderFns }